import React from 'react';
import styles from './Box.module.scss';
import Avatar from '@material-ui/core/Avatar';
import { 
  Card, 
  CardMedia, 
  CardActionArea 
} from '@material-ui/core';
import {
 Title,
 Container,
 Rating,
 Star,
 StyledAvatar
} from './styled';
 

interface Props  {
  adult?: boolean
  backdrop_path?: string
  genre_ids?: any[]
  id?: number
  original_language?: string
  original_title?: string
  overview?: string
  popularity?: number
  poster_path?: string
  release_date?: string
  title: string
  video?: boolean
  vote_average?: number
  vote_count: number,
  showRating?:boolean,
  showTitle?:boolean,
  size?:string,
  type?:string
  onClick?: () => void,
};

/**
 * Box
 * Renders a "box" like a container with different shape(story vs classic).
 * @see Docs https://reach.tech/skip-nav#skipnavlink
 * @param {boolean} adult
 * @param {string} backdrop_path
 * @param {*} genre_ids
 * @param {string} id
 * @param {string} original_language
 * @param {*} original_title
 * @param {string} overview
 * @param {number} popularity
 * @param {string} poster_path
 * @param {string} release_date
 * @param {string} title
 * @param {boolean} video
 * @param {number} vote_average
 * @param {function} onClick
 * @param {number}  vote_count
 * @param {bollean} showRating
 * @param {bollean} showTitle
 * @param {string} size
 * @param {string} type
 * @return {*}
 * @final
*/

export const Box = ({
   poster_path,
   title,
   vote_average,
   showTitle,
   showRating,
   size,
   type,
   release_date,
   onClick
}: Props) => {
    
    return type === 'story' 
      ? <StyledAvatar  
        src={`https://image.tmdb.org/t/p/original/${poster_path}`} 
        onClick={onClick}
       />
      
       : <Container>  
          <Card  onClick={onClick} className={styles.movie}>
              <CardActionArea>
              <CardMedia
                className={size === 'small' ? styles.image : styles.bigImage}
                image={`https://image.tmdb.org/t/p/original/${poster_path}`}
                title={title}
              />
            </CardActionArea>
          </Card>

          {showTitle && 
          <Title 
              variant="subtitle2" 
              color="textPrimary" 
              gutterBottom>
              {title} ({release_date.slice(0,4)})
          </Title>
          }

          <div className={styles.rateWrapper}>
            {showRating && 
            <React.Fragment>
            <Star />
            <Rating 
                variant="subtitle2" 
                color="textPrimary" 
                gutterBottom>
              {vote_average}
            </Rating>
            </React.Fragment>
            }
          </div>
      </Container>
};